/**
 * Alert 유틸리티
 * 사용자에게 메시지를 표시하는 함수
 */

export async function showAlert(message: string): Promise<void> {
  // 브라우저 기본 alert 사용
  // 실제로는 토스트 메시지 또는 모달로 구현 가능
  alert(message);
}
